import {asset} from 'imba';
import url from './mobile.png';
export default asset({
	url: url,
	type: 'image',
	width: 1024,
	height: 418,
	toString: function(){ return this.url;}
})